import { IaCookie } from '@/models/cookie'
import type { AuthCookieModel } from '@/models/auth'

export const useAuth = () => {
  const authData = useCookie<AuthCookieModel | null>(IaCookie.Authorization)
  const isAuthenticated = computed(() => isDefined(authData))

  return {
    isAuthenticated,
    authData,
  }
}
